import { render, staticRenderFns } from "./CardTablero.vue?vue&type=template&id=637b53e8&scoped=true&"
import script from "./CardTablero.vue?vue&type=script&lang=js&"
export * from "./CardTablero.vue?vue&type=script&lang=js&"
import style0 from "./CardTablero.vue?vue&type=style&index=0&id=637b53e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b53e8",
  null
  
)

export default component.exports